<template>
  <div
      class="date-picker"
      :class="{ 'with-border': hasBorder }"
  >
    <!-- 类型选择按钮 -->
    <div class="type-buttons">
      <el-button
          v-for="(type, index) in types"
          :key="type"
          :type="selectedTypeIndex === index ? 'primary' : 'default'"
          size="small"
          @click="selectType(index)"
      >
        {{ type }}
      </el-button>
    </div>

    <!-- 时间选择框 -->
    <div class="time-container">
      <el-select
          v-model="selectedValue"
          placeholder="请选择时间"
          @change="emitDateChange"
      >
        <el-option
            v-for="option in options"
            :key="option.value"
            :label="option.label"
            :value="option.value"
        />
      </el-select>
    </div>

    <!-- 确定按钮 -->
    <div>
      <el-button type="primary" @click="confirmSelection">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DatePicker",
  props: {
    hasBorder: {
      type: Boolean,
      default: true, // 默认显示边框
    },
  },
  data() {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;
    const currentQuarter = Math.ceil(currentMonth / 3);

    return {
      types: ["年度", "季度", "月度"],
      selectedTypeIndex: 2,
      selectedValue: null,
      options: [],
      currentYear,
      currentQuarter,
      currentMonth,
    };
  },
  computed: {
    selectedType() {
      return this.types[this.selectedTypeIndex];
    },
  },
  mounted() {
    this.updateOptions();
    this.setDefaultValue();
  },
  methods: {
    updateOptions() {
      const {currentYear, currentQuarter, currentMonth} = this;
      if (this.selectedType === "年度") {
        this.options = Array.from(
            {length: currentYear - 2023},
            (_, i) => ({
              value: `${2024 + i}年度`,
              label: `${2024 + i}年度`,
            })
        );
      } else if (this.selectedType === "季度") {
        const quarters = [];
        for (let year = 2024; year <= currentYear; year++) {
          const maxQuarter = year === currentYear ? currentQuarter : 4;
          for (let quarter = 1; quarter <= maxQuarter; quarter++) {
            quarters.push({
              value: `${year}-Q${quarter}`,
              label: `${year}年第${quarter}季度`,
            });
          }
        }
        this.options = quarters;
      } else if (this.selectedType === "月度") {
        const months = [];
        for (let year = 2024; year <= currentYear; year++) {
          const startMonth = year === 2024 ? 3 : 1;
          const endMonth = year === currentYear ? currentMonth : 12;
          for (let month = startMonth; month <= endMonth; month++) {
            months.push({
              value: `${year}-${month}`,
              label: `${year}年${month}月`,
            });
          }
        }
        this.options = months;
      }
    },
    setDefaultValue() {
      if (this.selectedType === "年度") {
        this.selectedValue = `${this.currentYear}年度`;
      } else if (this.selectedType === "季度") {
        this.selectedValue = `${this.currentYear}-Q${this.currentQuarter}`;
      } else if (this.selectedType === "月度") {
        this.selectedValue = `${this.currentYear}-${this.currentMonth}`;
      }
      this.emitDateChange();
    },
    emitDateChange() {
      this.$emit("date-change", {
        type: this.selectedType,
        value: this.selectedValue,
      });
    },
    selectType(index) {
      if (this.selectedTypeIndex !== index) {
        this.selectedTypeIndex = index;
        this.updateOptions();
        this.setDefaultValue();
      }
    },
    confirmSelection() {
      this.$emit("confirm-selection", {
        type: this.selectedType,
        value: this.selectedValue,
      });
    },
  },
};
</script>

<style scoped>
.date-picker {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 10px;
  background-color: #fff;
  border-radius: 5px;
}

.date-picker.with-border {
  border: 1px solid #ddd;
}

.type-buttons {
  display: flex;
  gap: 8px;
}

.time-container {
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// DateSelection.vue?186b3bcb